import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./app/pages/Auth/Login";
import Screens from "./app/pages/Screens/Screens";
import Dashboard from "./app/pages/Dashboard/Dashboard";
import Campaigns from "./app/pages/Campaigns/Campaigns";
import AddCompaigns from "./app/pages/Campaigns/AddCompaigns";
import CampaignDetails from "./app/pages/Campaigns/CampaignDetails";
import Vehicles from "./app/pages/Vehicles/Vehicles";
import Companies from "./app/pages/Companies/Companies";
import Owners from "./app/pages/Owner/Owners";
import OwnerDetails from "./app/pages/Owner/OwnerDetails";
import ScreenDetails from "./app/pages/Screens/ScreenDetails";
import EntertainmentVideos from "./app/pages/EntertainmentVideos/Entertainementvideo";
import AddEntertainmentVideos from "./app/pages/EntertainmentVideos/AddEntertainmentVideos";
import EntertainmentVideosDetails from "./app/pages/EntertainmentVideos/EntertainmentVideoDetails";
import Restaurants from "./app/pages/Resturants/Resturants";
import RestaurantDetails from "./app/pages/Resturants/ResturantDetails";
import AddRestaurant from "./app/pages/Resturants/AddRestaurant";
import Configuration from "./app/pages/Configuration/Configuration";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/screens" element={<Screens />} />
        <Route path="/screendetails/:id" element={<ScreenDetails />} />
        <Route path="/mobileLocations" element={<Vehicles />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/fixedLocations" element={<Restaurants />} />
        <Route path="/infotainmentvideos" element={<EntertainmentVideos />} />
        <Route
          path="/infotainmentvideos/:id"
          element={<EntertainmentVideosDetails />}
        />
        <Route path="/campaigns/add" element={<AddCompaigns />} />
        <Route
          path="/infotainmentvideos/add"
          element={<AddEntertainmentVideos />}
        />
        <Route
          path="/infotainmentvideos/edit/:id"
          element={<AddEntertainmentVideos />}
        />
        <Route path="/campaigndetails/:id" element={<CampaignDetails />} />
        <Route path="/fixedLocations/:id" element={<RestaurantDetails />} />
        <Route path="/fixedLocations/add" element={<AddRestaurant />} />
        <Route path="/fixedLocations/edit/:id" element={<AddRestaurant />} />
        <Route path="/campaigns/edit/:id" element={<AddCompaigns />} />
        <Route path="/companies" element={<Companies />} />
        <Route path="/owners" element={<Owners />} />
        <Route path="/owners/:ownerId" element={<OwnerDetails />} />
        <Route path="/configurations" element={<Configuration />} />
      </Routes>
    </Router>
  );
}

export default App;
